import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import theme from '../../theme';
import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { Box, Button, LinearProgress, Modal, styles as styled, Tooltip } from '@mui/material/';
import { useNavigate, useNavigation } from 'react-router-dom';
// import "./styles.css";
import Slider from '@mui/material/Slider';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
  convertToPercent, getCompsetName, round, getNumDaysFromDateRange, safeReference, dateDiff,
  isString, isEmptyObj, getFromState, getTransformedSegments, getRestrictionsStr, getStringFromHTML,
  numberFormatForReport, truncate, isNumber, dateFormat, deepCopy, processColumnsNew, getAppData, divide, generateTable, getPermissions,
  getStayToSdly, getStayToComp, getFromSession, isDateInRange, getDemandImpactName, getDemandImpactColor
} from "../../app/util";
import { CloseSharp as CloseSharpIcon, Label } from '@mui/icons-material';
import moment from 'moment';
import { DateRangePicker } from 'react-date-range';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format, addDays, differenceInDays } from 'date-fns';
import { FileUploader } from "react-drag-drop-files";
import DataService from "../../services/data.service";
import { error } from "highcharts";
import { fetchDataSimple } from "../../services/data.service";
import { UPDATE_STATE } from '../../actions/types';
import DynamicAlert from "./DynamicAlert";
const token = getFromSession("token");


const SigmaDashboard = (props) => {
  const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const state = useSelector(state => state);
  const { auth, app } = state;
  const { profile } = auth;
  const {
    profile: { property_details },
    user,
  } = useSelector((state) => state.auth);

  const { app_state, ui_state } = useSelector(
    (state) => state.app.current_state
  );

  const username = (user && user.fullname) ? user.fullname : "";
  const { property_id } = app_state;
  const { propertyChangeErrorMsg } = ui_state;
  const { permissions } = getPermissions(property_details, property_id);
  let url = "pending...";
  const [urlStatus, setUrlStatus] = useState("pending");

  function goBackToDashboard() {
    dispatch({
      type: UPDATE_STATE,
      payload: {
        app_state: {
          data_load: true,
          kpi_load: true,
        },
        ui_state: {
          active_settings_menu: "",
          showspinner: true,
        }
      },
    });
    navigate("/");
  }


  const handleSubmit = () => {
    let asOfDate = app_state.primary_stay_range.as_of_date;
    let fromDate = app_state.primary_stay_range.date_from;
    let toDate = app_state.primary_stay_range.date_until;
    // let apiUrl = "ea/s/url/?eaReportId=" + app_state.workspace_controls.sigma_report_id +
    //          "&propertyId=" + app_state.property_id +
    //          "&asOfDate=" + encodeURIComponent(asOfDate) +
    //          "&fromDate=" + encodeURIComponent(fromDate) +
    //          "&toDate=" + encodeURIComponent(toDate);
    let apiUrl = "ea/s/url/?eaReportId=" + app_state.workspace_controls.sigma_report_id + "&propertyId=" + app_state.property_id;
    let request = { method: "GET" }
    fetchDataSimple({ api: apiUrl, request }).then(res => {
      controls.sigmaDashboard = true;
      controls.sigmaDashboardUrl = res.url;
      setUrlStatus(res.url);
      dispatch({
        type: UPDATE_STATE,
        payload: {
          app_state: {
            workspace_controls: controls,
          },
        }
      });
    })
  }

  useEffect(() => {
    if (app_state.workspace_controls.sigma_report_id) {
      handleSubmit();
    }
  }, [app_state.workspace_controls.sigma_report_id])

  useEffect(() => {
    let propVarient = property_details.find((propertyEle) => propertyEle.id === property_id)?.product_variant;
    let sigmaReportsArr = propVarient?.ea_reports;
    const exists = sigmaReportsArr[0];
    let reportId = '';
    let label = '';
    let sigmaDashboardUrl = 'pending';
    if (permissions && permissions.ea && exists && exists.id) {
      reportId = exists.id;
      dispatch({
        type: UPDATE_STATE,
        payload: {
          app_state: {
            workspace_controls: {
              ...app_state.workspace_controls,
              sigma_report_id: '',
              sigmaDashboardUrl: ''
            },
          },
        }
      });
    } else {
      sigmaDashboardUrl = 'no-access';
    }
    setUrlStatus(sigmaDashboardUrl);

    setTimeout(() => {
      dispatch({
        type: UPDATE_STATE,
        payload: {
          app_state: {
            workspace_controls: {
              ...app_state.workspace_controls,
              sigma_report_id: reportId,
              sigmaDashboardUrl: sigmaDashboardUrl
            },
          },
        }
      });
    }, 1000);

    return () => {
      dispatch({
        type: UPDATE_STATE,
        payload: {
          ui_state: {
            propertyChangeErrorMsg: false,
          }
        }
      });
    };

  }, [property_id])

  const handlePopupClose = useCallback(() => {
    window.propertyClicked = '';
    dispatch({
      type: UPDATE_STATE,
      payload: {
        ui_state: {
          propertyChangeErrorMsg: false,
        }
      }
    });
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        {/* Header Start */}
        <Box>
          <Header />
        </Box>
        {/* Header End */}

        <Box sx={{ pt: "60px", height: "100%" }}>
          <Box className='top-axn-bar-1'>
            <Box sx={{ml:1}} className='back-to-dashboard' onClick={goBackToDashboard}><svg width="53" height="16" viewBox="0 0 53 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 14.5C9.28558 14.5 10.5423 14.1188 11.6112 13.4046C12.6801 12.6903 13.5132 11.6752 14.0052 10.4874C14.4972 9.29972 14.6259 7.99279 14.3751 6.73191C14.1243 5.47104 13.5052 4.31285 12.5962 3.40381C11.6872 2.49476 10.529 1.8757 9.26809 1.6249C8.00721 1.37409 6.70028 1.50281 5.51256 1.99478C4.32484 2.48675 3.30968 3.31987 2.59545 4.38879C1.88122 5.45771 1.5 6.71442 1.5 8C1.50182 9.72335 2.18722 11.3756 3.40581 12.5942C4.6244 13.8128 6.27665 14.4982 8 14.5ZM8 2.5C9.0878 2.5 10.1512 2.82257 11.0556 3.42692C11.9601 4.03127 12.6651 4.89025 13.0813 5.89524C13.4976 6.90023 13.6065 8.0061 13.3943 9.073C13.1821 10.1399 12.6583 11.1199 11.8891 11.8891C11.1199 12.6583 10.1399 13.1821 9.07299 13.3943C8.0061 13.6065 6.90023 13.4976 5.89524 13.0813C4.89024 12.6651 4.03126 11.9601 3.42691 11.0556C2.82257 10.1512 2.5 9.0878 2.5 8C2.50165 6.54182 3.08165 5.14383 4.11274 4.11274C5.14383 3.08165 6.54182 2.50165 8 2.5ZM5.14625 8.35375C5.09976 8.30731 5.06288 8.25217 5.03772 8.19147C5.01256 8.13077 4.9996 8.06571 4.9996 8C4.9996 7.93429 5.01256 7.86923 5.03772 7.80853C5.06288 7.74783 5.09976 7.69269 5.14625 7.64625L7.14625 5.64625C7.24007 5.55243 7.36732 5.49972 7.5 5.49972C7.63268 5.49972 7.75993 5.55243 7.85375 5.64625C7.94757 5.74007 8.00028 5.86732 8.00028 6C8.00028 6.13268 7.94757 6.25993 7.85375 6.35375L6.70687 7.5L10.5 7.5C10.6326 7.5 10.7598 7.55268 10.8536 7.64645C10.9473 7.74021 11 7.86739 11 8C11 8.13261 10.9473 8.25978 10.8536 8.35355C10.7598 8.44732 10.6326 8.5 10.5 8.5L6.70687 8.5L7.85375 9.64625C7.94757 9.74007 8.00028 9.86732 8.00028 10C8.00028 10.1327 7.94757 10.2599 7.85375 10.3537C7.75993 10.4476 7.63268 10.5003 7.5 10.5003C7.36732 10.5003 7.24007 10.4476 7.14625 10.3537L5.14625 8.35375Z" fill="#00415F" />
              <path d="M28.5352 12H25.0605V3.54492H28.459C29.252 3.54492 29.873 3.73437 30.3223 4.11328C30.7754 4.48828 31.002 5.00195 31.002 5.6543C31.002 6.0957 30.8594 6.49219 30.5742 6.84375C30.2891 7.19141 29.9375 7.40039 29.5195 7.4707V7.57031C30.0898 7.62891 30.5488 7.8457 30.8965 8.2207C31.248 8.5918 31.4238 9.05273 31.4238 9.60352C31.4238 10.3496 31.168 10.9355 30.6562 11.3613C30.1445 11.7871 29.4375 12 28.5352 12ZM26.373 4.6582V7.125H27.9316C28.5098 7.125 28.9473 7.02148 29.2441 6.81445C29.5449 6.60352 29.6953 6.29688 29.6953 5.89453C29.6953 5.50391 29.5586 5.20117 29.2852 4.98633C29.0156 4.76758 28.6387 4.6582 28.1543 4.6582H26.373ZM26.373 10.8867H28.2715C28.8613 10.8867 29.3105 10.7695 29.6191 10.5352C29.9277 10.3008 30.082 9.95898 30.082 9.50977C30.082 9.06836 29.9219 8.73438 29.6016 8.50781C29.2812 8.27734 28.8125 8.16211 28.1953 8.16211H26.373V10.8867ZM35.0508 11.0449C35.5234 11.0449 35.916 10.9121 36.2285 10.6465C36.5449 10.3809 36.7031 10.0488 36.7031 9.65039V9.11719L35.1445 9.2168C34.707 9.24414 34.3848 9.33398 34.1777 9.48633C33.9707 9.63867 33.8672 9.85547 33.8672 10.1367C33.8672 10.418 33.9766 10.6406 34.1953 10.8047C34.4141 10.9648 34.6992 11.0449 35.0508 11.0449ZM34.7285 12.1055C34.1035 12.1055 33.5918 11.9316 33.1934 11.584C32.7988 11.2324 32.6016 10.7695 32.6016 10.1953C32.6016 9.625 32.8066 9.17773 33.2168 8.85352C33.627 8.52539 34.2129 8.33789 34.9746 8.29102L36.7031 8.19141V7.64062C36.7031 7.30078 36.5918 7.04102 36.3691 6.86133C36.1465 6.67773 35.8223 6.58594 35.3965 6.58594C35.0449 6.58594 34.752 6.64844 34.5176 6.77344C34.2871 6.89453 34.1367 7.06836 34.0664 7.29492H32.8477C32.9102 6.74805 33.1777 6.3125 33.6504 5.98828C34.127 5.66016 34.7285 5.49609 35.4551 5.49609C36.252 5.49609 36.8672 5.68555 37.3008 6.06445C37.7383 6.43945 37.957 6.96484 37.957 7.64062V12H36.7441V11.1035H36.6445C36.4531 11.4238 36.1895 11.6719 35.8535 11.8477C35.5215 12.0195 35.1465 12.1055 34.7285 12.1055ZM45.1523 7.70508H43.9277C43.8496 7.38086 43.6797 7.11914 43.418 6.91992C43.1602 6.7207 42.8281 6.62109 42.4219 6.62109C41.8945 6.62109 41.4785 6.8125 41.1738 7.19531C40.873 7.57812 40.7227 8.10938 40.7227 8.78906C40.7227 9.47656 40.873 10.0176 41.1738 10.4121C41.4785 10.8027 41.8945 10.998 42.4219 10.998C42.8242 10.998 43.1543 10.9082 43.4121 10.7285C43.6738 10.5488 43.8457 10.2891 43.9277 9.94922H45.1523C45.0703 10.6055 44.7891 11.1328 44.3086 11.5312C43.8281 11.9258 43.2012 12.123 42.4277 12.123C41.498 12.123 40.7656 11.8281 40.2305 11.2383C39.6992 10.6445 39.4336 9.82812 39.4336 8.78906C39.4336 7.76562 39.6992 6.96094 40.2305 6.375C40.7617 5.78906 41.4922 5.49609 42.4219 5.49609C43.1992 5.49609 43.8262 5.69922 44.3027 6.10547C44.7832 6.51172 45.0664 7.04492 45.1523 7.70508ZM48.0117 8.2793L50.543 5.61914H52.0312L49.4062 8.35547L52.207 12H50.6602L48.4688 9.1875L47.9121 9.71484V12H46.6523V3.12891H47.9121V8.2793H48.0117Z" fill="#00415F" />
            </svg>
            </Box>
            <Box className="event-page-title" style={{ justifyContent: "center", width: "100%" }}>
              {/* {eventsIconBlack} */}
              Business Intelligence
            </Box>
          </Box>

          {!['pending', 'no-access'].includes(urlStatus) && <iframe src={urlStatus} height="91%" width="100%" frameBorder={"none"} />}
          {['pending'].includes(urlStatus) && <LinearProgress />}
          {['no-access'].includes(urlStatus) && <DynamicAlert purpose="no-access" showAlert={true} message="Don't have permission to access this report. Please contact to Administrator." />}
          {propertyChangeErrorMsg && <DynamicAlert purpose="property-change" username={username} handleClose={handlePopupClose} showAlert={true} message="Analytics Report is not enable for this property. Please contact to Administrator." />}
        </Box>
        {/* Footer Start */}
        <Box>
          <DashboardFooter />
        </Box>
        {/* Footer End */}


      </ThemeProvider>
    </>
  )
}

export default SigmaDashboard
